import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { LanguageProvider } from "./context/LanguageContext";
import { DataProvider } from "./context/DataContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Projects from "./pages/Projects";
import Process from "./pages/Process";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Heritage from "./pages/Heritage";
import Academy from "./pages/Academy";
import ApplicationGuide from "./pages/ApplicationGuide";
import Admin from "./pages/Admin";
import { Toaster } from "./components/ui/toaster";
import { trackEvent } from "./lib/track";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PageTracker() {
  const { pathname } = useLocation();
  const lastPath = React.useRef(null);
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    if (lastPath.current === pathname) return;
    lastPath.current = pathname;
    trackEvent("pageview", pathname);
  }, [pathname]);
  return null;
}

function Layout({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Header />}
      <main>{children}</main>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppButton />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <DataProvider>
          <BrowserRouter>
            <ScrollToTop />
            <PageTracker />
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/product-category/:slug" element={<Shop />} />
                <Route path="/urun/:slug" element={<ProductDetail />} />
                <Route path="/all-projects" element={<Projects />} />
                <Route path="/how-we-do" element={<Process />} />
                <Route path="/nasil-uygulanir" element={<ApplicationGuide />} />
                <Route path="/akademi" element={<Academy />} />
                <Route path="/about" element={<About />} />
                <Route path="/heritage" element={<Heritage />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </Layout>
            <Toaster />
          </BrowserRouter>
        </DataProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
